import baseAPI from '@/api/base';
import {
  EditEvent,
  GetEvent,
  RegisterEvent,
} from '@/dtos/event.dto';
import {
  DELETE_EVENT_URL,
  EDIT_EVENT_URL,
  GET_EVENT_URL,
  REGISTER_EVENT_URL,
  TOGGLE_EVENT_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Event {
  static getEvents = async (
    getEvent: GetEvent
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EVENT_URL, {
      params: getEvent,
    });
    console.log('response', response);
    return response;
  };

  static registerEvent = async (  
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_EVENT_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    console.log('response', response);
    return response;
  };

  static editEvent = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_EVENT_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };

  static toggleEventIsActive = async (
    editEvent: EditEvent
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EVENT_IS_ACTIVE_URL,
      {
        ...editEvent,
      }
    );
    return response;
  };

  static deleteEvent = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EVENT_URL}/${id}`
    );
    return response;
  };
}

export default Event;
